import React, { createContext, useContext } from "react";

export const SiteContext = createContext();

const SiteProvider = ({ site, children }) => (
  <SiteContext.Provider value={site}>{children}</SiteContext.Provider>
);

export const useSite = () => useContext(SiteContext);

export default SiteProvider;
